// Global browser API setup if needed
// This file is optional and can be used for global setup

// Initialize Netlify Identity for Decap CMS
if (typeof window !== 'undefined' && window.netlifyIdentity) {
  window.netlifyIdentity.on('init', (user) => {
    if (!user) {
      window.netlifyIdentity.on('login', () => {
        document.location.href = '/admin/'
      })
    }
  })
}

